// Table menu handler functions for panels and stock sheets

/**
 * Enable all panels
 * @param {Array} panels - Current panels array
 * @param {Function} setPanels - State setter for panels
 * @param {Function} handlePanelsMenuClose - Function to close the panels menu
 */
export const handleEnableAllPanels = (panels, setPanels, handlePanelsMenuClose) => {
  setPanels(panels.map(panel => ({ ...panel, enabled: true })));
  handlePanelsMenuClose();
};

/**
 * Disable all panels
 * @param {Array} panels - Current panels array
 * @param {Function} setPanels - State setter for panels
 * @param {Function} handlePanelsMenuClose - Function to close the panels menu
 */
export const handleDisableAllPanels = (panels, setPanels, handlePanelsMenuClose) => {
  setPanels(panels.map(panel => ({ ...panel, enabled: false })));
  handlePanelsMenuClose();
};

/**
 * Clear all panels
 * @param {Function} setPanels - State setter for panels
 * @param {Function} handlePanelsMenuClose - Function to close the panels menu
 */
export const handleClearPanels = (setPanels, handlePanelsMenuClose) => {
  if (window.confirm('Are you sure you want to clear all panels?')) {
    setPanels([{ width: '', length: '', quantity: '', materialType: '', label: '', enabled: true, grainDirection: 'either' }]);
  }
  handlePanelsMenuClose();
};

/**
 * Enable all stock sheets
 * @param {Array} stockSheets - Current stock sheets array
 * @param {Function} setStockSheets - State setter for stock sheets
 * @param {Function} handleStockMenuClose - Function to close the stock menu
 */
export const handleEnableAllStock = (stockSheets, setStockSheets, handleStockMenuClose) => {
  setStockSheets(stockSheets.map(stock => ({ ...stock, enabled: true })));
  handleStockMenuClose();
};

/**
 * Disable all stock sheets
 * @param {Array} stockSheets - Current stock sheets array
 * @param {Function} setStockSheets - State setter for stock sheets
 * @param {Function} handleStockMenuClose - Function to close the stock menu
 */
export const handleDisableAllStock = (stockSheets, setStockSheets, handleStockMenuClose) => {
  setStockSheets(stockSheets.map(stock => ({ ...stock, enabled: false })));
  handleStockMenuClose();
};

/**
 * Clear all stock sheets
 * @param {Function} setStockSheets - State setter for stock sheets
 * @param {Function} handleStockMenuClose - Function to close the stock menu
 */
export const handleClearStock = (setStockSheets, handleStockMenuClose) => {
  if (window.confirm('Are you sure you want to clear all stock sheets?')) {
    setStockSheets([{ width: '', length: '', quantity: '', materialType: '', enabled: true, grainDirection: 'either' }]);
  }
  handleStockMenuClose();
};

